import { render, staticRenderFns } from "./EditSimple.vue?vue&type=template&id=4b240016&"
import script from "./EditSimple.vue?vue&type=script&lang=js&"
export * from "./EditSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b240016')) {
      api.createRecord('4b240016', component.options)
    } else {
      api.reload('4b240016', component.options)
    }
    module.hot.accept("./EditSimple.vue?vue&type=template&id=4b240016&", function () {
      api.rerender('4b240016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EditSimple.vue"
export default component.exports